var map = {
	"./Galerija/Images/Hero.jpg": 9644,
	"./Kontakt/Images/Hero.jpg": 7120,
	"./NacinPlacanja/Images/Hero.jpg": 452,
	"./ONama/Images/Hero.jpg": 448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 828;